import { useState } from 'react';
import toast from 'react-hot-toast';
import { useBusinessStore } from '../store/useBusinessStore';
import { useAuthStore } from '../store/useAuthStore';
import { supabase } from '../supabaseClient';
import { addTestNumber, botMode, removeTestNumber, testNumbersOf } from '../utils/botTestMode';

const DEMO_BUSINESS_IDS = ['9001', '9002', '9003'];
const isMissingColumn = (error) => ['42703', 'PGRST204'].includes(error?.code) || /bot_modo_prueba|numeros_prueba/i.test(error?.message || '');

// Modo prueba del negocio activo: números de prueba y el paso de «encender para todos». Todo se guarda en la base antes de reflejarse en pantalla.
export const useBotTestMode = () => {
  const { masterDb, activeBusinessId, setMasterDb } = useBusinessStore();
  const { userRole } = useAuthStore();
  const [saving, setSaving] = useState(false);
  const business = (Array.isArray(masterDb) ? masterDb : []).find((b) => String(b.id) === String(activeBusinessId)) || null;
  const readOnlyDemo = DEMO_BUSINESS_IDS.includes(String(activeBusinessId)) && userRole !== 'master';

  const save = async (patch, okMessage) => {
    if (!business) return false;
    if (readOnlyDemo) { toast.error('Modo solo lectura: las cuentas demo no se pueden modificar.'); return false; }
    setSaving(true);
    try {
      const { error } = await supabase.from('businesses').update(patch).eq('id', business.id);
      if (error) {
        toast.error(isMissingColumn(error)
          ? 'Falta ejecutar la migración 20261005b_bot_test_mode.sql en Supabase para usar el modo prueba.'
          : 'No se pudo guardar. Inténtalo de nuevo.');
        return false;
      }
      setMasterDb((current) => (Array.isArray(current) ? current : []).map((b) => (String(b.id) === String(business.id) ? { ...b, ...patch } : b)));
      if (okMessage) toast.success(okMessage);
      return true;
    } finally {
      setSaving(false);
    }
  };

  const numbers = testNumbersOf(business);
  return {
    business, saving, readOnlyDemo, numbers, mode: botMode(business),
    addNumber: async (input, prefix) => {
      const r = addTestNumber(numbers, input, prefix);
      if (r.error) { toast.error(r.error); return false; }
      return save({ numeros_prueba: r.list }, 'Número de prueba agregado');
    },
    removeNumber: (number) => save({ numeros_prueba: removeTestNumber(numbers, number) }, 'Número quitado'),
    publish: () => save({ bot_modo_prueba: false }, 'El bot ya responde a todos tus clientes'),
    backToTest: () => save({ bot_modo_prueba: true }, 'El bot quedó en modo prueba')
  };
};
